import type { ListSort } from "./pagination.models";
import { sortSchema } from "./pagination.models";

/**
 * Columns the super-admin Stripe-event list can be ordered by.
 *
 * The list is capped rather than paginated, so the ordering decides which events
 * come back, not just their arrangement — which is why it is resolved in the query.
 */
export const STRIPE_EVENT_SORT_KEYS = ["createdAt", "status"] as const;

export const stripeEventSortSchema = sortSchema(STRIPE_EVENT_SORT_KEYS);

export type StripeEventSortKey = (typeof STRIPE_EVENT_SORT_KEYS)[number];
export type StripeEventSort = ListSort<StripeEventSortKey>;

/** Newest-first, which is the ordering the list has always applied. */
export const DEFAULT_STRIPE_EVENT_SORT: StripeEventSort = {
  key: "createdAt",
  direction: "desc",
};
